import React from 'react'
import { M_Table } from 'src/components/M_Components'

export const InsuranceType = ({ roles }) => {

    return (
        <M_Table entityName={'InsuranceType'} filtersOnTable rolePermissions={roles} />
    )
}